import setup from './moduleSetup';

export default {
    name: 'vendorSideMenuItems',
    before: [],
    after: [],
    setup,
};
